(() => {
  if (window.__NT_EMPTY_CART_DRAG_LOADED__) return;
  window.__NT_EMPTY_CART_DRAG_LOADED__ = true;

  const DRAG_THRESHOLD = 10;

  let state = {
    scroller: null,
    pointerId: null,
    startX: 0,
    startY: 0,
    startScrollLeft: 0,
    dragging: false,
    suppressNextClick: false,
  };


  document.addEventListener('pointerdown', (event) => {

    /*
     * Touch / Finger NICHT mit JS behandeln.
     * Dadurch bleibt natives Mobile-Swipen erhalten.
     */
    if (event.pointerType !== 'mouse') {
      return;
    }


    const scroller = event.target.closest(
      '.nt-empty-cart__products-scroller'
    );

    if (!scroller) return;


    /*
     * Nur linke Maustaste
     */
    if (event.button !== 0) {
      return;
    }


    state.scroller = scroller;
    state.pointerId = event.pointerId;

    state.startX = event.clientX;
    state.startY = event.clientY;

    state.startScrollLeft =
      scroller.scrollLeft;

    state.dragging = false;
    state.suppressNextClick = false;
  });


  document.addEventListener(
    'pointermove',
    (event) => {

      /*
       * Nur Maus behandeln.
       * Touch bleibt komplett nativ.
       */
      if (event.pointerType !== 'mouse') {
        return;
      }


      if (!state.scroller) return;


      if (
        event.pointerId !==
        state.pointerId
      ) {
        return;
      }


      const deltaX =
        event.clientX -
        state.startX;


      const deltaY =
        event.clientY -
        state.startY;


      /*
       * Erst bei mindestens 10px
       * horizontaler Bewegung draggen.
       */
      if (!state.dragging) {

        if (
          Math.abs(deltaX) <
          DRAG_THRESHOLD
        ) {
          return;
        }


        /*
         * Wenn stärker vertikal bewegt wird,
         * nicht horizontal draggen.
         */
        if (
          Math.abs(deltaY) >
          Math.abs(deltaX)
        ) {
          return;
        }


        state.dragging = true;


        state.scroller.classList.add(
          'is-dragging'
        );


        try {
          state.scroller.setPointerCapture(
            event.pointerId
          );
        } catch (_) {}
      }


      if (!state.dragging) return;


      state.scroller.scrollLeft =
        state.startScrollLeft -
        deltaX;


      /*
       * Nur bei Desktop-Maus verhindern.
       */
      event.preventDefault();
    },
    {
      passive: false,
    }
  );


  function stopDrag(event) {

    /*
     * Touch ignorieren.
     */
    if (event.pointerType !== 'mouse') {
      return;
    }


    if (!state.scroller) return;


    if (
      event.pointerId !==
      state.pointerId
    ) {
      return;
    }


    const scroller =
      state.scroller;


    const wasDragging =
      state.dragging;


    scroller.classList.remove(
      'is-dragging'
    );


    if (wasDragging) {
      state.suppressNextClick = true;
    }


    try {
      scroller.releasePointerCapture(
        event.pointerId
      );
    } catch (_) {}


    state.scroller = null;
    state.pointerId = null;
    state.dragging = false;
  }


  document.addEventListener(
    'pointerup',
    stopDrag
  );


  document.addEventListener(
    'pointercancel',
    stopDrag
  );


  /*
   * Nur den Klick direkt nach einem
   * echten Desktop-Drag blockieren.
   *
   * Normale Klicks auf Produkte
   * funktionieren weiterhin.
   */
  document.addEventListener(
    'click',
    (event) => {

      if (!state.suppressNextClick) {
        return;
      }


      const insideProducts =
        event.target.closest(
          '.nt-empty-cart__products-scroller'
        );


      if (!insideProducts) {

        state.suppressNextClick =
          false;

        return;
      }


      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      state.suppressNextClick =
        false;
    },
    true
  );


  /*
   * Browser-eigenes Bild-Dragging
   * auf Desktop verhindern.
   */
  document.addEventListener(
    'dragstart',
    (event) => {

      if (
        event.target.closest(
          '.nt-empty-cart__products-scroller'
        )
      ) {
        event.preventDefault();
      }

    }
  );

})();